<template>
	<div>
		<div class="columns">
			<div class="column is-4">
				<nav class="breadcrumb has-succeeds-separator has-text-weight-bold" aria-label="breadcrumbs">
					<ul>
						<li><a rel="noreferrer" :href="`/${this.sitelocale}`">{{t('home')}}</a></li>
						<li class="is-active"><a rel="noreferrer" href="#" aria-current="page">{{t('all_categories')}}</a></li>
					</ul>
				</nav>
			</div>
		</div>
		<div v-if="categories.length >=1" v-infinite-scroll="loadNextPage" infinite-scroll-disabled="busy" infinite-scroll-distance="12">
			<div class="columns is-multiline is-mobile mt40">
				<div class="column is-2-desktop is-4-tablet is-12-mobile wow zoomIn" data-wow-duration="1s" data-wow-delay=".5s" v-for="category in categories">
					<div class="p10">
						<a rel="noreferrer" class="is-block has-background-warning pt30 pb30 pr20 pl20 has-text-centered card has-text-white dashed-bg hvr-radial-out overflow-hidden" :href="category.route">
                            <i :class="`${category.icon} icon-4rem`"></i>
							<p class="has-text-weight-bold height-50 overflow-hidden">{{ category.name }}</p>
						</a>
					</div>
				</div>
			</div>
			<div class="has-text-centered" v-show="loadMore">
				<a rel="noreferrer" class="button is-primary hvr-shutter-out-vertical hvr-warning is-rounded p25 pr40 pl40" href="#">{{t('load_more')}}</a>
			</div>
		</div>
		<div v-else>
			<figure class="image image-contain height-330">
				<img src="/front/img/empty.svg">
			</figure>
		</div>
	</div>
</template>
<script>
	import axios from 'axios';
	import infiniteScroll from 'vue-infinite-scroll';
	import trans from '../translation/categories.json';
	export default {
	name: 'CategoriesPage',
	directives: {
		infiniteScroll
	},
	props: {
		url: String,
		sitelocale:{
			type:String,
			required: true
		}
	},
	computed: {
		busy() {
			return this.fetching
		}
	},
	mounted() {
		this.$translate.setLang(this.sitelocale);
	},
	locales: trans,
	data: () => ({
		currentPage: 0,
		fetching: false,
        categories: [],
		nextUrl : String,
		loadMore : true,
		isActive: false
	}),
	methods: {
		loadNextPage() {
			this.currentPage++;
			this.fetching = true;
			if(this.nextUrl != null){
				axios.get(this.nextUrl).then(({ data }) => {
					this.categories.push(...data.data);
					if(data.links.next != null) {
						this.nextUrl = data.links.next;
					} else {
						this.nextUrl = data.links.next;
					}
					this.fetching = false;
				});
			}
			else{
				this.loadMore = false;
			}
		}
	},
	created() {
		this.nextUrl = this.url;
		this.categories = [];
		this.loadNextPage();
	}
};
</script>
